import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetLoansList = params => {
  return useQuery({
    queryKey: [QUERY_KEYS.loan.list, params],
    refetchOnWindowFocus: false,
    queryFn: () =>
      loanService.list(params).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
      }),
  });
};
